import { configureApiClient } from '@alpha/api-client';

/**
 * Sanctum SPA cookie mode. The session and refresh tokens live in httpOnly
 * SameSite=Strict cookies set by Laravel — nothing auth-related is ever written
 * to localStorage. Because the browser attaches those cookies automatically,
 * the CSRF layer inside the client is load-bearing, not decorative.
 */
export const apiClient = configureApiClient({
  baseURL: '/api',
  sanctumBaseURL: '',
  loginPath: '/login',
});
